import React, { useEffect, useRef, useState } from 'react';
import { View, Animated, Dimensions } from 'react-native';
import Svg, { Path } from 'react-native-svg';

interface AnimatedWaveProps {
  height?: number;
  amplitude?: number;
  opacity?: number;
  color?: string;
  flip?: boolean;
  speed?: number;
}

export default function AnimatedWave({
  height = 150,
  amplitude = 30,
  opacity = 0.25,
  color = '#64c8ff',
  flip = false,
  speed = 1,
}: AnimatedWaveProps) {
  const [phase, setPhase] = useState(0);
  const { width } = Dimensions.get('window');

  useEffect(() => {
    let animationFrameId: number;
    let startTime = Date.now();

    const animate = () => {
      const elapsed = (Date.now() - startTime) / 1000;
      setPhase(elapsed * speed);
      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [speed]);

  const generateWavePath = (): string => {
    const points: string[] = [];
    const step = 10;
    const scaleY = flip ? -1 : 1;
    const baseline = height * 0.4;

    points.push(`M -50 ${baseline}`);

    for (let i = -50; i <= width + 50; i += step) {
      const x = i;
      const angle = i / 60 + phase;
      const y = baseline + Math.sin(angle) * amplitude * scaleY;
      points.push(`L ${x} ${y}`);
    }

    points.push(`L ${width + 50} ${height}`);
    points.push(`L -50 ${height}`);
    points.push('Z');

    return points.join(' ');
  };

  return (
    <View style={{ width: '100%', height }}>
      <Svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid slice"
      >
        <Path d={generateWavePath()} fill={color} fillOpacity={opacity} />
      </Svg>
    </View>
  );
}
